import Step from 'shepherd.js/src/types/step';
import { TourSteps } from './interface/tour-steps.interface';

export const assignCreateMealPlanStep: (tourSteps: TourSteps) => Step.StepOptions[] =
  ({ steps, buttons, services, events }: TourSteps): Step.StepOptions[] => {
    return [
      {
        ...steps.default,
        id: 'registerMealPlanStep4',
        title: 'Barra de herramientas', // pendiente
        text: `Puedes consultar información respecto a los datos que vayas ingresando, además de realizar algunas acciones al plan alimenticio.`,
        attachTo: {
          element: '.toolbar',
          on: 'bottom'
        },
        canClickTarget: false,
        buttons: [
          {
            // tslint:disable-next-line:typedef
            action(): void {
              return this.next();
            },
            text: 'Siguiente'
          },
          { ...buttons.cancel }
        ],
      },
      {
        ...steps.default,
        id: 'registerMealPlanStep5',
        title: 'Estándares de planes de alimentación',
        text: `Puedes elegir entre dos formas de crear tu plan alimenticio: siguiendo el estándar SMAE o el estándar Internacional. Por defecto estará seleccionado el tipo SMAE.`,
        attachTo: {
          element: '.meal-plan-options',
          on: 'bottom'
        },
        canClickTarget: false,
        buttons: [
          {
            // tslint:disable-next-line:typedef
            action(): void {
              return this.next();
            },
            text: 'Siguiente'
          },
          { ...buttons.cancel }
        ],
      },
      {
        ...steps.default,
        id: 'registerMealPlanStep1',
        title: 'Medición',
        text: `Elige la medición.`,
        attachTo: {
          element: '.chose-measurement',    // @ts-ignore
          on: 'bottom'
        },
        canClickTarget: false,
        buttons: [
          {
            // tslint:disable-next-line:typedef
            action(): void {
              return this.next();
            },
            text: 'Siguiente'
          },
          { ...buttons.cancel }
        ],
        beforeShowPromise: () => {
          return new Promise((resolve): void => {
            setTimeout((): void => {
              events.events.emit('setMeasurementValue');
              resolve(true);
            }, 500);
          });
        },
      },
      {
        ...steps.default,
        id: 'registerMealPlanStep1',
        title: 'Disminuye calorías',
        text: `Puedes disminuir calorías a la medición elegida. Por defauil se encuentra seleccionada esta opción.`,
        attachTo: {
          element: '.decrease-calories',    // @ts-ignore
          on: 'bottom'
        },
        advanceOn: {
          selector: '.decrease-calories',
          event: 'click',
        },
        buttons: [{ ...buttons.cancel }],
      },
      {
        ...steps.default,
        id: 'registerMealPlanStep1',
        title: 'Aumenta calorías',
        text: `Puedes aumentar calorías a la medición elegida.`,
        attachTo: {
          element: '.increase-calories',    // @ts-ignore
          on: 'bottom'
        },
        advanceOn: {
          selector: '.increase-calories',
          event: 'click',
        },
        buttons: [{ ...buttons.cancel }],
      },
      {
        ...steps.default,
        id: 'registerMealPlanStep1',
        title: 'Campo texto calorías',
        text: `Puedes ingresar el total de calorías a diminuir o aumentar, dependiendo de la opción elegida. Para efectos del tour aumentamos 150 kcal`,
        attachTo: {
          element: '.input-calories',    // @ts-ignore
          on: 'bottom'
        },
        canClickTarget: false,
        buttons: [
          {
            // tslint:disable-next-line:typedef
            action(): void {
              return this.next();
            },
            text: 'Siguiente'
          },
          { ...buttons.cancel }],
        beforeShowPromise: () => {
          return new Promise((resolve): void => {
            setTimeout((): void => {
              events.events.emit('setCaloriesValue');
              resolve(true);
            }, 500);
          });
        },
      },
      {
        ...steps.default,
        id: 'registerMealPlanStep8',
        title: 'Estándar de distribución',
        text: `Se muestran los valores de macronutrientes elegidos por el experto, respecto al estándar seleccionado.`,
        attachTo: {
          element: '.distribution-standart',
          on: 'top'
        },
        canClickTarget: false,
        buttons: [{
          // tslint:disable-next-line:typedef
          action(): void {
            return this.next();
          },
          text: 'Siguiente'
        },
        { ...buttons.cancel }
        ],
      },
      {
        ...steps.default,
        id: 'registerMealPlanStep6',
        title: 'Seguimiento de calorías',
        text: `Se muestra información sobre la meta de calorías deseada.`,
        attachTo: {
          element: '.meal-plan-calories',
          on: 'bottom'
        },
        canClickTarget: false,
        buttons: [
          {
            // tslint:disable-next-line:typedef
            action(): void {
              return this.next();
            },
            text: 'Siguiente'
          },
          { ...buttons.cancel }
        ],
      },
      {
        ...steps.default,
        id: 'registerMealPlanStep8',
        title: 'Selecciona el estándar de distribución',
        text: `Puedes seleccionar entre los diferentes estándares de distribución de macronutrientes.`,
        attachTo: {
          element: '.select-strategy',
          on: 'bottom'
        },
        canClickTarget: false,
        buttons: [
          {
            // tslint:disable-next-line:typedef
            action(): void {
              return this.next();
            },
            text: 'Siguiente'
          },
          { ...buttons.cancel }
        ],
        beforeShowPromise: () => {
          return new Promise((resolve): void => {
            services.utilitiesService.scrollToElement('.select-strategy', { behavior: 'auto', block: 'center', inline: 'center' });
            resolve(true);
          });
        }
      },
      {
        ...steps.default,
        id: 'registerMealPlanStep8',
        title: 'Meta de calorías',
        text: `Se muestra la meta deseada de calorías del plan alimenticio.`,
        attachTo: {
          element: '.total-calories',
          on: 'bottom'
        },
        canClickTarget: false,
        buttons: [
          {
            // tslint:disable-next-line:typedef
            action(): void {
              return this.next();
            },
            text: 'Siguiente'
          },
          { ...buttons.cancel }
        ],
      },
      {
        ...steps.default,
        id: 'registerMealPlanStep7',
        title: '',
        text: `Se muestra el nombre del macronutriente.`,
        attachTo: {
          element: '.macronutrient-name',
          on: 'top'
        },
        canClickTarget: false,
        buttons: [
          {
            // tslint:disable-next-line:typedef
            action(): void {
              return this.next();
            },
            text: 'Siguiente'
          },
          { ...buttons.cancel }
        ],
      },
      {
        ...steps.default,
        id: 'registerMealPlanStep7',
        title: 'Bloquear macronutriente',
        text: `Puedes bloquear máximo 2 macronutrientes para que sus valores no sean cambiados.`,
        attachTo: {
          element: '.block-macronutient-0 .ant-checkbox-input',
          on: 'top'
        },
        buttons: [
          {
            // tslint:disable-next-line:typedef
            action(): void {
              return this.next();
            },
            text: 'Siguiente'
          },
          { ...buttons.cancel }
        ],
      },
      {
        ...steps.default,
        id: 'registerMealPlanStep7',
        title: 'total',
        text: `Se muestra el total en gramos del macronutriente que tiene el plan alimenticio.`,
        attachTo: {
          element: '.block-macronutient-0 .tag-item:nth-child(1)',
          on: 'top'
        },
        canClickTarget: false,
        buttons: [
          {
            // tslint:disable-next-line:typedef
            action(): void {
              return this.next();
            },
            text: 'Siguiente'
          },
          { ...buttons.cancel }
        ]
      },
      {
        ...steps.default,
        id: 'registerMealPlanStep7',
        title: 'total por periodo',
        text: `Se muestra el total en gramos del macronutriente que tiene el periodo seleccionado del plan alimenticio.`,
        attachTo: {
          element: '.block-macronutient-0 .tag-item:nth-child(2)',
          on: 'top'
        },
        canClickTarget: false,
        buttons: [
          {
            // tslint:disable-next-line:typedef
            action(): void {
              return this.next();
            },
            text: 'Siguiente'
          },
          { ...buttons.cancel }
        ],
      },
      {
        ...steps.default,
        id: 'registerMealPlanStep7',
        title: 'Referencia',
        text: `Se muestra el porcentaje de referencia del estándar de distribución elegido.`,
        attachTo: {
          element: '.block-macronutient-0 .tag-item:nth-child(3)',
          on: 'top'
        },
        canClickTarget: false,
        buttons: [
          {
            // tslint:disable-next-line:typedef
            action(): void {
              return this.next();
            },
            text: 'Siguiente'
          },
          { ...buttons.cancel }
        ],
      },
      {
        ...steps.default,
        id: 'registerMealPlanStep7',
        title: 'valor actual',
        text: `Se muestra el valor elegido por el experto para este macronutriente.`,
        attachTo: {
          element: '.block-macronutient-0 .tag-item:nth-child(4)',
          on: 'top'
        },
        canClickTarget: false,
        buttons: [
          {
            // tslint:disable-next-line:typedef
            action(): void {
              return this.next();
            },
            text: 'Siguiente'
          },
          { ...buttons.cancel }
        ],
      },
      {
        ...steps.default,
        id: 'registerMealPlanStep7',
        title: 'Gramos',
        text: `Se muestra el total en gramos que se requiere para cumplir la meta de calorías.`,
        attachTo: {
          element: '.block-macronutient-0 .tag-item:nth-child(5)',
          on: 'top'
        },
        canClickTarget: false,
        buttons: [
          {
            // tslint:disable-next-line:typedef
            action(): void {
              return this.next();
            },
            text: 'Siguiente'
          },
          { ...buttons.cancel }
        ],
      },
      {
        ...steps.default,
        id: 'registerMealPlanStep8',
        title: 'Valor actual',
        text: `Se puede modificar el porcentaje deseado del macronutriente, deslizando la barra o ingresando directamente el valor en el campo numérico.`,
        attachTo: {
          element: '.slider-macronutrient-distribution-0',
          on: 'top'
        },
        buttons: [
          {
            // tslint:disable-next-line:typedef
            action(): void {
              return this.next();
            },
            text: 'Siguiente'
          },
          { ...buttons.cancel }
        ],
        beforeShowPromise: () => {
          return new Promise((resolve): void => {
            services.utilitiesService.scrollToElement('.slider-macronutrient-distribution-0', { behavior: 'auto', block: 'center', inline: 'center' });
            resolve(true);
          });
        }
      },
      {
        ...steps.default,
        id: 'registerMealPlanStep8',
        title: 'Valor actual',
        text: `Son los gramos por kilogramo del paciente en base al plan de alimentación.`,
        attachTo: {
          element: '.data-info:nth-child(1)',
          on: 'top'
        },
        buttons: [
          {
            // tslint:disable-next-line:typedef
            action(): void {
              return this.next();
            },
            text: 'Siguiente'
          },
          { ...buttons.cancel }
        ],
      },
      {
        ...steps.default,
        id: 'registerMealPlanStep8',
        title: 'Meta SMAE',
        text: `Son los gramos por kilogramo del paciente en base a la meta.`,
        attachTo: {
          element: '.data-info:nth-child(2)',
          on: 'top'
        },
        buttons: [
          {
            // tslint:disable-next-line:typedef
            action(): void {
              return this.next();
            },
            text: 'Siguiente'
          },
          { ...buttons.cancel }
        ],
      },
      {
        ...steps.default,
        id: 'registerMealPlanStep8',
        title: 'Tabla macronutrimental',
        text: `Puedes establecer la cantidad deseada de cada categoría alimenticia. Además de ver su equivalente en porciones y la adecuación de SMAE.`,
        attachTo: {
          element: '.nutrient-table',
          on: 'top'
        },
        canClickTarget: false,
        buttons: [
          {
            // tslint:disable-next-line:typedef
            action(): void {
              return this.next();
            },
            text: 'Siguiente'
          },
          { ...buttons.cancel }
        ],
      },
      {
        ...steps.default,
        id: 'registerMealPlanStep8',
        title: 'Categoría',
        text: `Nombre de la categoría.`,
        attachTo: {
          element: 'tr.category-0 td:nth-child(1)',
          on: 'top'
        },
        canClickTarget: false,
        buttons: [
          {
            // tslint:disable-next-line:typedef
            action(): void {
              return this.next();
            },
            text: 'Siguiente'
          },
          { ...buttons.cancel }
        ],
      },
      {
        ...steps.default,
        id: 'registerMealPlanStep8',
        title: 'Cantidad',
        text: `Puedes agregar la cantidad de ingredientes deseada pertenecientes a la categoría. Para efectos del tour ingresamos una cantidad de 4 verduras.`,
        attachTo: {
          element: 'tr.category-0  td:nth-child(2) .ant-input-number',
          on: 'top'
        },
        canClickTarget: false,
        buttons: [
          {
            // tslint:disable-next-line:typedef
            action(): void {
              return this.next();
            },
            text: 'Siguiente'
          },
          { ...buttons.cancel }
        ],
        beforeShowPromise: () => {
          return new Promise((resolve): void => {
            events.events.emit('setQuantityIngredient');
            services.utilitiesService.scrollToElement('tr.category-0 td:nth-child(2)', { behavior: 'auto', block: 'start', inline: 'end' });
            resolve(true);
          });
        }
      },
      {
        ...steps.default,
        id: 'registerMealPlanStep8',
        title: 'Cantidad de calorías',
        text: `Es el equivalente en calorías de la cantidad de ingredientes ingreseados.`,
        attachTo: {
          element: 'tr.category-0  td:nth-child(4)',
          on: 'top'
        },
        canClickTarget: false,
        buttons: [
          {
            // tslint:disable-next-line:typedef
            action(): void {
              return this.next();
            },
            text: 'Siguiente'
          },
          { ...buttons.cancel }
        ],
        beforeShowPromise: () => {
          return new Promise((resolve): void => {
            services.utilitiesService.scrollToElement('tr.category-0 td:nth-child(4)', { behavior: 'auto', block: 'start', inline: 'end' });
            resolve(true);
          });
        }
      },
      {
        ...steps.default,
        id: 'registerMealPlanStep8',
        title: 'Cantidad de proteínas',
        text: `Es el equivalente en gramos de proteínas de la cantidad de ingredientes ingreseados.`,
        attachTo: {
          element: 'tr.category-0  td:nth-child(6)',
          on: 'top'
        },
        canClickTarget: false,
        buttons: [
          {
            // tslint:disable-next-line:typedef
            action(): void {
              return this.next();
            },
            text: 'Siguiente'
          },
          { ...buttons.cancel }
        ],
        beforeShowPromise: () => {
          return new Promise((resolve): void => {
            services.utilitiesService.scrollToElement('tr.category-0 td:nth-child(6)', { behavior: 'auto', block: 'start', inline: 'end' });
            resolve(true);
          });
        }
      },
      {
        ...steps.default,
        id: 'registerMealPlanStep8',
        title: 'Cantidad de lípidos',
        text: `Es el equivalente en gramos de lípidos de la cantidad de ingredientes ingreseados.`,
        attachTo: {
          element: 'tr.category-0  td:nth-child(8)',
          on: 'top'
        },
        canClickTarget: false,
        buttons: [
          {
            // tslint:disable-next-line:typedef
            action(): void {
              return this.next();
            },
            text: 'Siguiente'
          },
          { ...buttons.cancel }
        ],
        beforeShowPromise: () => {
          return new Promise((resolve): void => {
            services.utilitiesService.scrollToElement('tr.category-0 td:nth-child(8)', { behavior: 'auto', block: 'start', inline: 'end' });
            resolve(true);
          });
        }
      },
      {
        ...steps.default,
        id: 'registerMealPlanStep8',
        title: 'Cantidad de carbohidratos',
        text: `Es el equivalente en gramos de carbohidratos de la cantidad de ingredientes ingreseados.`,
        attachTo: {
          element: 'tr.category-0 td:nth-child(10)',
          on: 'top'
        },
        canClickTarget: false,
        buttons: [
          {
            // tslint:disable-next-line:typedef
            action(): void {
              return this.next();
            },
            text: 'Siguiente'
          },
          { ...buttons.cancel }
        ],
        beforeShowPromise: () => {
          return new Promise((resolve): void => {
            services.utilitiesService.scrollToElement('tr.category-0 td:nth-child(10)', { behavior: 'auto', block: 'start', inline: 'end' });
            resolve(true);
          });
        }
      },
      {
        ...steps.default,
        id: 'registerMealPlanStep8',
        title: 'Construir plan de alimentación',
        text: `Una vez agregados los valores en la tabla macronutrimental puedes comenzar a crear tu plan alimenticio. Da clic en el botón para continuar.`,
        attachTo: {
          element: '.button-build-plan',
          on: 'top'
        },
        advanceOn: {
          selector: '.button-build-plan',
          event: 'click'
        },
        buttons: [
          { ...buttons.cancel }
        ],
      },
      {
        ...steps.default,
        id: 'registerMealPlanStep6',
        title: 'Macronutrines',
        text: `Se muestran los valores de macronutrientes del plan alimenticio actual.`,
        attachTo: {
          element: '.meal-plan-macronutrient',
          on: 'bottom'
        },
        canClickTarget: false,
        buttons: [
          {
            // tslint:disable-next-line:typedef
            action(): void {
              return this.next();
            },
            text: 'Siguiente'
          },
          { ...buttons.cancel }
        ],
      },
      {
        ...steps.default,
        id: 'registerMealPlanStep6',
        title: 'Micronutrientes',
        text: `Se muestran los valores de micronutrientes que contiene el plan alimenticio actual.`,
        attachTo: {
          element: '.meal-plan-micronutrient',
          on: 'bottom'
        },
        canClickTarget: false,
        buttons: [
          {
            // tslint:disable-next-line:typedef
            action(): void {
              return this.next();
            },
            text: 'Siguiente'
          },
          { ...buttons.cancel }
        ],
      },
      {
        ...steps.default,
        id: 'registerMealPlanStep1',
        title: 'Nombra tu plan de alimentación',
        text: `Nombre del plan, los buscadores usarán este valor para encontrarlo. Para fines del tour, se ha definido un nombre.`,
        attachTo: {
          element: '.input-name-meal-plan',
          on: 'bottom'
        },
        canClickTarget: false,
      },
      {
        ...steps.default,
        id: 'registerMealPlanStep2',
        title: 'Describe tu plan de alimentación',
        text: `Esta descripción será vista por quienes utilicen tu plan de alimentación.`,
        attachTo: {
          element: '.input-description-meal-plan',
          on: 'bottom'
        },
        canClickTarget: false,
      },
      {
        ...steps.default,
        id: 'registerMealPlanStep2',
        title: 'Plan de alimentación visible',
        text: `Si habilitas esta opción el plan de alimentación será visible y podrás asignarlo a otros pacientes, si deseas que el plan sea único para este paciente mantenlo deshabilitado.`,
        attachTo: {
          element: '.nz-switch-enable-meal-plan',
          on: 'bottom'
        },
      },
      {
        ...steps.default,
        id: 'registerMealPlanStep4',
        scrollTo: {
          inline: 'end',
          block: 'center',
          behavior: 'smooth',
        },
        title: '¿Qué son los periodos?',
        text: `Un periodo es un conjunto de comidas o instrucciones, como por ejemplo, las comidas que tendrá el paciente durante un día.`,
        attachTo: {
          element: '.fit-content-tab-nav-operation',
          on: 'bottom'
        },
        canClickTarget: false,
        beforeShowPromise: () => {
          return new Promise((resolve): void => {
            services.utilitiesService.scrollToElement('.fit-content-tab-nav-operation', { behavior: 'auto', block: 'center', inline: 'center'});
            resolve(true);
          });
        }
      },
      {
        ...steps.default,
        scrollTo: {
          inline: 'end',
          block: 'center',
          behavior: 'smooth',
        },
        id: 'registerMealPlanStep4',
        title: 'Plantillas de plan alimenticio',
        text: `Son plantillas creadas por el sistema, con periodos y tiempos de comida predefinidos. No te preocupes, siempre puedes modificar la plantilla elegida.`,
        attachTo: {
          element: '.template-plans',
          on: 'bottom'
        },
        canClickTarget: false,
      },
      {
        ...steps.default,
        id: 'registerMealPlanStep4',
        title: 'Plantilla de un solo día',
        text: `Esta plantilla cuenta con un periodo y 5 tiempos de comida.`,
        attachTo: {
          element: '.template-plan-day',
          on: 'bottom'
        },
        canClickTarget: false,
        buttons: [
          {
            // tslint:disable-next-line:typedef
            action(): void {
              return this.next();
            },
            text: 'Siguiente'
          },
          { ...buttons.cancel }
        ],
      },
      {
        ...steps.default,
        id: 'registerMealPlanStep4',
        title: 'Plantilla de una semana',
        text: `Esta plantilla cuenta con 7 periodos y 5 tiempos de comida cada uno.`,
        attachTo: {
          element: '.template-plan-week',
          on: 'bottom'
        },
        canClickTarget: false,
        buttons: [
          {
            // tslint:disable-next-line:typedef
            action(): void {
              return this.next();
            },
            text: 'Siguiente'
          },
          { ...buttons.cancel }
        ],
      },
      {
        ...steps.default,
        id: 'registerMealPlanStep4',
        title: 'Plantilla personalizada',
        text: `Esta plantilla se encuentra vacía para poder editarla a conveniencia. Esta es la plantilla por defecto.`,
        attachTo: {
          element: '.template-plan-custom',
          on: 'bottom'
        },
        canClickTarget: false,
        buttons: [
          {
            // tslint:disable-next-line:typedef
            action(): void {
              return this.next();
            },
            text: 'Siguiente'
          },
          { ...buttons.cancel }
        ],
      },
      {
        ...steps.default,
        scrollTo: {
          inline: 'end',
          block: 'center',
          behavior: 'smooth',
        },
        id: 'registerMealPlanStep5',
        title: 'Añade tu primer tiempo de comida',
        text: `Puedes agregar uno o varios tiempos de comida. Da clic para continuar.`,
        attachTo: {
          element: '.add-time',
          on: 'bottom'
        },
        advanceOn: {
          selector: '.add-time',
          event: 'click'
        },
        buttons: [{ ...buttons.cancel }],
      },
      {
        ...steps.default,
        scrollTo: {
          inline: 'end',
          block: 'center',
          behavior: 'smooth',
        },
        id: 'registerMealPlanStep6',
        title: 'Nombra tu tiempo de comida',
        text: `Para fines del tour, se ha definido este tiempo de comida como "Desayuno".`,
        attachTo: {
          element: '.input-name-time-food',
          on: 'bottom'
        },
        canClickTarget: false,
      },
      {
        ...steps.default,
        id: 'registerMealPlanStep7',
        title: 'Horario recomendado',
        text: `Puedes agregar un horario recomendado, sin embargo, no es requerido. Para fines de este tour, se ha definido que el tiempo de comida debe ser a las 8 de la mañana.`,
        attachTo: {
          element: '.hour',
          on: 'bottom'
        },
        canClickTarget: false,
      },
      {
        ...steps.default,
        id: 'registerMealPlanStep8',
        title: 'Tipo',
        text: `Aquí podrás escoger el tipo del tiempo de comida. La opción "Receta" nos permite seleccionar alguna receta creada en el sistema, la opción "Ingrediente" nos permitirá definir los alimentos que tendrá el tiempo de comida y finalmente la opción "Instrucción" permitirá dejar algún comentario.`,
        attachTo: {
          element: '.type-container',
          on: 'bottom'
        },
        canClickTarget: false,
      },
      {
        ...steps.default,
        id: 'registerMealPlanStep8',
        title: 'Instrucciones',
        text: `Permite escribir un comentario al paciente. Da clic para continuar.`,
        attachTo: {
          element: '.meal-plan-type-2',
          on: 'bottom'
        },
        advanceOn: {
          selector: '.meal-plan-type-2',
          event: 'click',
        },
        buttons: [
          { ...buttons.cancel },
        ]
      },
      {
        ...steps.default,
        id: 'registerMealPlanStep8',
        title: 'Instrucciones',
        text: `Aquí podrás escribir las instrucciones que consideres necesarias. Para fines del tour, se ha agregado una breve instrucción.`,
        attachTo: {
          element: '.shepherd-textarea',
          on: 'bottom'
        },
        canClickTarget: false,
      },
      {
        ...steps.default,
        id: 'registerMealPlanStep11',
        title: 'Guarda tu primer tiempo de comida',
        text: `Si ya tienes todos los datos válidos puedes guardarlo. Da clic en el botón para continuar.`,
        attachTo: {
          element: '.btn-save-time-food',
          on: 'bottom'
        },
        advanceOn: {
          selector: '.btn-save-time-food',
          event: 'click'
        },
        //  canClickTarget: false,
        buttons: [{ ...buttons.cancel }],
      },
      {
        ...steps.default,
        id: 'registerMealPlanStep5',
        title: 'Comparativa de macronutrientes',
        text: `Muestra la comparativa de los macronutrientes de la meta de SMAE contra los del plan de alimentación.`,
        attachTo: {
          element: '.meal-plan-alert',
          on: 'bottom'
        },
        canClickTarget: false,
        buttons: [
          {
            // tslint:disable-next-line:typedef
            action(): void {
              return this.next();
            },
            text: 'Siguiente'
          },
          { ...buttons.cancel }
        ],
      },
      {
        ...steps.default,
        id: 'registerMealPlanStep6',
        title: 'Tabla de resultados SMAE',
        text: `Se muestra la comparación entre la tabla macronutrimental y el plan alimenticio actual.`,
        attachTo: {
          element: '.meal-plan-results',
          on: 'bottom'
        },
        canClickTarget: false,
        buttons: [
          {
            // tslint:disable-next-line:typedef
            action(): void {
              return this.next();
            },
            text: 'Siguiente'
          },
          { ...buttons.cancel }
        ],
      },
      {
        ...steps.default,
        id: 'registerMealPlanStep8',
        title: 'Mostrar pautas SMAE',
        text: `No te preocupes, siempre puedes regresar a modificar la tabla macronutrimental.`,
        attachTo: {
          element: '.show-guidelines',
          on: 'top'
        },
        canClickTarget: false,
        buttons: [
          {
            // tslint:disable-next-line:typedef
            action(): void {
              return this.next();
            },
            text: 'Siguiente'
          },
          { ...buttons.cancel }
        ],

      },
      /* {
        ...steps.default,
        id: 'registerMealPlanStep6',
        title: 'Tabla de porciones objetivo de SMAE',
        text: `Se muestra la comparación entre las porciones deseadas de la tabla macroutrimental y las porciones del plan alimenticio actual.`,
        attachTo: {
          element: '.meal-plan-portion',
          on: 'bottom'
        },
        canClickTarget: false,
        buttons: [
          {
            // tslint:disable-next-line:typedef
            action(): void {
              return this.next();
            },
            text: 'Siguiente'
          },
          { ...buttons.cancel }
        ],
      }, */
      {
        ...steps.default,
        id: 'registerMealPlanStep10',
        title: 'Meta de calorías',
        text: `Aquí puedes modificar directamente la meta de calorías.`,
        attachTo: {
          element: '.collapse-calorie-tracking',
          on: 'top'
        },
        canClickTarget: false,
        buttons: [
          {
            // tslint:disable-next-line:typedef
            action(): void {
              return this.next();
            },
            text: 'Entendido'
          },
          { ...buttons.cancel }
        ],
        classes: undefined,
        beforeShowPromise: () => {
          return new Promise((resolve) => {
            events.events.emit('openCollapseCaloriesTracking');
            resolve(true);
          });
        }
      },
      {
        ...steps.default,
        id: 'registerMealPlanStep10',
        title: 'Distribución',
        text: `Se muestran los valores de distribución de macronutrientes elegidos anteriormente. Si deseas hacer modificaciones debes regresar a las pautas SMAE.`,
        attachTo: {
          element: '.collapse-distribution',
          on: 'top'
        },
        canClickTarget: false,
        buttons: [
          {
            // tslint:disable-next-line:typedef
            action(): void {
              return this.next();
            },
            text: 'Entendido'
          },
          { ...buttons.cancel }],
        classes: undefined,
        beforeShowPromise: () => {
          return new Promise((resolve): void => {
            setTimeout((): void => {
              events.events.emit('openCollapseDistribution');
              resolve(true);
            }, 500);
          });
        },
      },
      {
        ...steps.default,
        id: 'registerMealPlanStep10',
        title: 'Gráfica de macronutrientes',
        text: `Una vez agregados los alimentos al plan, se mostrará una gráfica con la distribución de macronutrientes.`,
        attachTo: {
          element: '.collapse-macronutients',
          on: 'top'
        },
        advanceOn: {
          selector: '.collapse-macronutients',
          event: 'click'
        },
        canClickTarget: false,
        buttons: [
          {
            // tslint:disable-next-line:typedef
            action(): void {
              return this.next();
            },
            text: 'Entendido'
          },
          { ...buttons.cancel }
        ],
        classes: undefined,
        beforeShowPromise: () => {
          return new Promise((resolve): void => {
            events.events.emit('openCollapseMacronutrient');
            setTimeout((): void => {
              resolve(true);
            }, 500);
          });
        },
      },
      {
        ...steps.default,
        id: 'registerMealPlanStep10',
        title: 'Micronutrientes',
        text: `Una vez agregados los alimentos al plan, se mostrará información de los micronutrientes y la referencia DDR.`,
        attachTo: {
          element: '.collapse-micronutients',
          on: 'top'
        },
        canClickTarget: false,
        advanceOn: {
          selector: '.collapse-micronutients',
          event: 'click'
        },
        buttons: [
          {
            // tslint:disable-next-line:typedef
            action(): void {
              return this.next();
            },
            text: 'Entendido'
          },
          { ...buttons.cancel }
        ],
        classes: undefined,
        beforeShowPromise: () => {
          return new Promise((resolve): void => {
            events.events.emit('openCollapseMicronutrient');
            setTimeout((): void => {
              resolve(true);
            }, 500);
          });
        },
      },
      {
        ...steps.default,
        id: 'registerMealPlanStep12',
        title: 'Asignar plan de alimentación',
        text: 'Una vez que tengas la información que requiere el plan de alimentación, tendrás que presionar el siguiente botón para asignar el plan al paciente.',
        attachTo: {
          element: '.shepherd-button-assign-meal-plan',
          on: 'bottom'
        },
        advanceOn: {
          selector: '.shepherd-button-assign-meal-plan',
          event: 'click',
        },
        buttons: [
          { ...buttons.cancel },
        ],
        canClickTarget: true,
      },
      {
        ...steps.default,
        id: 'registerMealPlanStep12',
        title: 'Ver el plan asignado al paciente',
        text: 'Da clic, para ver el plan de alimentación que fue asignado al paciente.',
        attachTo: {
          element: '.shepherd-button-assign-meal-plan-back',
          on: 'bottom'
        },
        advanceOn: {
          selector: '.shepherd-button-assign-meal-plan-back',
          event: 'click',
        },
        buttons: [
          { ...buttons.cancel },
        ],
        canClickTarget: true,
        beforeShowPromise: () => {
          return new Promise((resolve): void => {
            setTimeout((): void => {
              services.utilitiesService.existElementInDom().byClassName('shepherd-button-assign-meal-plan-back').subscribe({
                complete: () => resolve(true)
              });
            }, 1500);
          });
        },
      },
    ];
  };
